import { Component, OnInit } from '@angular/core';
declare var window: any;

@Component({
  selector: 'app-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.css']
})
export class PlaylistComponent implements OnInit {
  //Variáveis
  playlistUrl = 'https://youtube.com/playlist?list=PLbY7kD8djCeRrFCd9yPzvxrzniBULzBLD&si=2iY0HH4cILoZGVCe'; //Link Para Redirecionar

  constructor() { }

  ngOnInit(): void {
    //Microsoft Clarity
    window.clarity('event', 'TutorialRedirect');
    //Redirecionar Página
    window.location.replace(this.playlistUrl);
  }

}
